// Multi-language support for Work Calendar App
// Supported languages: English (en) and Croatian (hr)

export const LANGUAGES = {
  en: {
    code: 'en',
    name: 'English',
    flag: '🇺🇸'
  },
  hr: {
    code: 'hr',
    name: 'Hrvatski',
    flag: '🇭🇷'
  }
};

export const TRANSLATIONS = {
  en: {
    // Header
    appTitle: 'Work Control',
    welcome: 'Welcome',
    vacation: 'Vacation',
    carryOver: 'Carry Over',
    days: 'days',
    logout: 'Logout',

    // Navigation
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month',
    twoMonths: '2 Months',
    oneMonth: '1 Month',
    earliestAvailableMonth: 'Earliest Available Month',
    latestAvailableMonth: 'Latest Available Month',

    // Status Types
    statusTypes: {
      office: 'In Office',
      home: 'Work From Home',
      vacation: 'Vacation',
      sick: 'Sick Leave',
      other: 'Other Leave',
      parental_leave: 'Parental Leave',
      business_trip: 'Business Trip'
    },

    // General
    employee: 'Employee',
    admin: 'Admin',
    you: 'you',
    total: 'Total',
    close: 'Close',
    remove: 'Remove',

    // Dashboard
    collectiveVacation: 'Collective Vacation',
    enableAdminEdit: 'Enable Admin Editing',
    disableAdminEdit: 'Disable Admin Editing',
    adminEditOn: 'Admin Edit: ON',
    adminEditOff: 'Admin Edit: OFF',
    downloadExcelReport: 'Download Excel report for current month',
    downloadReport: 'Download Report',

    // Navigation
    dashboard: 'Dashboard',
    back: 'Back',

    // Admin Panel
    adminPanel: 'Admin Panel',
    userManagement: 'Employee Management',
    addUser: 'Add Employee',
    addNewUser: 'Add New Employee',
    editUser: 'Edit Employee',
    userDetails: 'User Details',
    employmentStartDate: 'Employment Start Date',
    deleteUser: 'Delete Employee',
    confirmDeleteUser: 'Are you sure you want to delete this employee?',
    createUser: 'Create Employee',
    allUsers: 'All Employees',
    username: 'Username',
    email: 'Email',
    firstName: 'First Name',
    lastName: 'Last Name',
    role: 'Role',
    vacationDays: 'Vacation Days',
    vacationNew: 'Vacation New',
    vacationCarryover: 'Vacation Carryover',
    calculatedVacation: 'Calculated Vacation for current year',
    actions: 'Actions',
    creating: 'Creating...',
    closeYear: 'Close Year {year}',
    closeYearTitle: 'Close year {year} and prepare {nextYear}',

    // Calendar
    today: 'Today',

    // Selection
    selectedDays: 'selected days',
    clearSelection: 'Clear Selection',
    setStatus: 'Set Status',
    selectedDates: 'Selected dates',

    // Modal
    setWorkStatus: 'Set Work Status',
    setStatusFor: 'Set status for',
    setStatusForDays: 'Set status for {count} selected days',
    setStatusForDate: 'Set status for {date}',
    orSelectDateRange: 'Or select date range:',
    startDate: 'Start Date',
    endDate: 'End Date',
    selectRange: 'Select Range',
    deleteStatus: 'Delete Status',
    deleteStatuses: 'Delete Statuses',
    cancel: 'Cancel',
    selectStatus: 'Choose status',
    selectedDaysCount: 'Selected {count} days',
    closeYearWarning: 'Are you sure you want to close year {year}? This action will create new vacation year records for all users and carry over remaining days. This action cannot be undone.',
    uploadDocument: 'Upload document (optional)',
    existingDocument: 'Existing document',
    replaceDocument: 'Replace document',
    cancelReplaceDocument: 'Keep existing document',
    selected: 'Selected: {name}',

    // Delete User Modal
    setEmploymentEndDate: 'Set the employment end date for user "{userName}". The user will remain visible in the system until this date.',
    employmentEndDate: 'Employment End Date',
    setDateAndDelete: 'Set End Date and Delete',

    // Year End Modal
    yearClosedSuccessfully: 'Year closed successfully!',

    // Generate report modal
    selectReportFormat: 'Select report format',
    perDay: 'Per day(xslx)',
    cummulative: 'Cummulative(xslx)',
    generateReport: 'Generate report',
    download: 'Download',

    // Collective Vacation Form
    errorSettingCollectiveVacation: 'Error setting collective vacation',
    setCollectiveVacattion: 'Set Collective Vacation',
    date: 'Date',
    description: 'Description(optional)',
    placeholder: 'e.g. Christmas holidays',
    existingCollectiveVacations: 'Existing Collective Vacations',
    noCollectiveVacations: 'No collective vacations found',
    confirmDeletion: 'Confirm deletion',
    deleteWarning: 'Are you sure you want to delete this {itemName} for {formattedDate}?',

    // Edit User Modal
    userNameRequired: 'Username is required',
    emailRequired: 'Email is required',
    firstNameRequired: 'First name is required',
    lastNameRequired: 'Last name is required',
    oibRequired: 'OIB is required',
    employmentTypeRequired: 'Employment type is required',
    employmentStartDateRequired: 'Employment start date is required',
    vacationContractRequired: 'Vacation contract is required',
    vacationDaysForCurrentYear: 'Vacation days for current year',
    employmentType: 'Employment Type',
    fullTime: "Full-time",
    partTime: "Part-time",
    editing: "Updating...",

    // Stats
    inOfficeToday: 'In Office Today',
    workingFromHome: 'Working from Home',
    onVacation: 'On Vacation',
    onLeave: 'On Leave',
    totalTeam: 'Total Team',

    // Alerts & Messages
    insufficientVacationDays: 'You are trying to book {requested} vacation day(s), but you only have {remaining} day(s) remaining.',
    insufficientVacationDaysTitle: 'Insufficient Vacation Days',
    insufficientVacationDaysMessage: 'You are trying to book {requested} vacation day(s), but you only have {remaining} day(s) remaining.',
    insufficientVacationDaysMessageAdmin: 'You are trying to book {requested} vacation day(s), but user only has {remaining} day(s) remaining.',
    pleaseAdjustSelection: 'Please adjust your selection to fit within your available vacation balance.',
    ok: 'OK',
    selectBothDates: 'Please select both start and end dates.',
    startDateBeforeEnd: 'Start date must be before or equal to end date.',
    invalidDateRange: 'Invalid date range.',
    errorDeletingCollectiveVacation: 'Error deleting collective vacation',
    error: 'Error: {error}',
    genericError: 'Error',
    unathorizedAccess: 'Unauthorized access',
    errorChangingPassword: 'Error changing password',

    // Login
    appName: 'Work Control',
    welcomeBack: 'Welcome back',
    signInSubtitle: 'Sign in to continue',
    usernamePlaceholder: 'Enter your username',
    emailAddress: 'Email address',
    enterEmail: 'Enter your email',
    password: 'Password',
    enterPassword: 'Enter your password',
    signIn: 'Sign in',
    signingIn: 'Signing in...',
    forgotPassword: 'Forgot your password?',
    demoCredentials: 'Demo Credentials',
    signInWithMicrosoft: 'Sign in with Microsoft',
    loginErrorNoAccount: 'No WorkControl account found for this email. Contact your administrator.',
    loginErrorCancelled: 'Sign-in was cancelled.',
    loginErrorGeneric: 'Sign-in with Microsoft failed. Please try again.',
    useCredentials: 'Use these credentials to test the app:',

    // Password Change
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    passwordChanged: 'Password changed successfully',
    incorrectPassword: 'Current password is incorrect',
    passwordMismatch: 'New passwords do not match',

    // Date formats
    monthYear: 'MMMM yyyy',
    dayMonth: 'MMM d',
    fullDate: 'MMMM d, yyyy'
  },

  hr: {
    // Header
    appTitle: 'Radna evidencija',
    welcome: 'Dobrodošli',
    vacation: 'Godišnji',
    carryOver: 'Stari GO',
    days: 'dana',
    logout: 'Odjava',

    // Navigation
    previousMonth: 'Prethodni Mjesec',
    nextMonth: 'Sljedeći Mjesec',
    twoMonths: '2 Mjeseca',
    oneMonth: '1 Mjesec',
    latestAvailableMonth: 'Najkasniji dostupan mjesec',
    earliestAvailableMonth: 'Najstariji dostupan mjesec',

    // Status Types
    statusTypes: {
      office: 'U Uredu',
      home: 'Rad Od Kuće',
      vacation: 'Godišnji',
      sick: 'Bolovanje',
      other: 'Slobodan dan',
      parental_leave: 'Porodiljni',
      business_trip: 'Službeni put'
    },

    // Navigation
    dashboard: 'Nadzorna Ploča',
    back: 'Nazad',

    // General
    employee: 'Zaposlenik',
    admin: 'Administrator',
    you: 'vi',
    total: 'Ukupno',
    close: 'Zatvori',
    remove: 'Ukloni',

    // Dashboard
    collectiveVacation: 'Kolektivni godišnji',
    enableAdminEdit: 'Omogući admin uređivanje',
    disableAdminEdit: 'Onemogući admin uređivanje',
    adminEditOn: 'Admin uređivanje uključeno',
    adminEditOff: 'Admin uređivanje isključeno',
    downloadExcelReport: 'Preuzmi Excel izvještaj za trenutni mjesec',
    downloadReport: 'Preuzmi izvještaj',

    // Admin Panel
    userManagement: 'Upravljanje Zaposlenicima',
    addUser: 'Dodaj Zaposlenika',
    addNewUser: 'Dodaj Novog Zaposlenika',
    createUser: 'Stvori Zaposlenika',
    deleteUser: 'Obriši Zaposlenika',
    editUser: 'Uredi Zaposlenika',
    userDetails: 'Detalji Zaposlenika',
    employmentStartDate: 'Datum zasnivanja radnog odnosa',
    allUsers: 'Svi Zaposlenici',
    firstName: 'Ime',
    lastName: 'Prezime',
    role: 'Uloga',
    vacationDays: 'Dani G.O.',
    vacationNew: 'Novi GO',
    vacationCarryover: 'Stari GO',
    calculatedVacation: 'Izračunati GO za tekuću godinu',
    actions: 'Akcije',
    creating: 'Stvaram...',
    closeYear: 'Zaključi godinu {year}',
    closeYearTitle: 'Zaključi godinu {year} i pripremi {nextYear}',
    closeYearWarning: 'Jeste li sigurni da želite zaključiti godinu {year}? Ova akcija će kreirati nove godišnje odmor zapise za sve korisnike i prenijeti preostale dane. Ova akcija se ne može poništiti.',

    // Delete User Modal
    setEmploymentEndDate: 'Postavite datum završetka radnog odnosa za korisnika "{userName}". Korisnik će ostati vidljiv u sustavu do ovog datuma.',
    employmentEndDate: 'Datum završetka radnog odnosa',
    setDateAndDelete: 'Postavi datum završetka i obriši',

    // Year End Modal
    yearClosedSuccessfully: 'Godina je uspješno zaključena!',

    // Generate report modal
    selectReportFormat: 'Odaberite format izvještaja',
    perDay: 'Po danu(xslx)',
    cummulative: 'Kumulativno(xslx)',
    generateReport: 'Generiraj izvještaj',
    download: 'Preuzmi',

    // Collective Vacation Form
    errorSettingCollectiveVacation: 'Greška pri postavljanju kolektivnog godišnjeg odmora',
    setCollectiveVacattion: 'Postavi kolektivni godišnji',
    date: 'Datum',
    description: 'Opis(opcionalno)',
    placeholder: 'npr. Božićni praznici',
    existingCollectiveVacations: 'Postojeći kolektivni godišnji',
    noCollectiveVacations: 'Nema postavljenih kolektivnih godišnjih odmora',
    confirmDeletion: 'Potvrdi brisanje',
    deleteWarning: 'Jeste li sigurni da želite obrisati {itemName} za {formattedDate}?',

    // Edit User Modal
    userNameRequired: 'Korisničko ime je obavezno',
    emailRequired: 'Email je obavezan',
    firstNameRequired: 'Ime je obavezno',
    lastNameRequired: 'Prezime je obavezno',
    oibRequired: 'OIB je obavezan',
    employmentTypeRequired: 'Tip zaposlenja je obavezan',
    employmentStartDateRequired: 'Datum zasnivanja radnog odnosa je obavezan',
    vacationContractRequired: 'Dani G.O. moraju biti veći od 0',
    employmentType: 'Tip zaposlenja',
    fullTime: 'Puno radno vrijeme',
    partTime: 'Pola radnog vremena',
    editing: 'Ažuriranje...',

    // Calendar
    today: 'Danas',

    // Selection
    selectedDays: 'dana',
    clearSelection: 'Očisti Odabir',
    setStatus: 'Postavi Status',
    selectedDates: 'Odabrani datumi',

    // Modal
    setWorkStatus: 'Postavi Radni Status',
    setStatusFor: 'Postavi status za',
    setStatusForDays: 'Postavi status za {count} odabranih dana',
    setStatusForDate: 'Postavi status za {date}',
    orSelectDateRange: 'Ili odaberite raspon datuma:',
    startDate: 'Početni Datum',
    endDate: 'Završni Datum',
    selectRange: 'Odaberi Raspon',
    deleteStatus: 'Obriši Status',
    deleteStatuses: 'Obriši Statuse',
    cancel: 'Odustani',
    selectStatus: 'Odaberite Status',
    selectedDaysCount: 'Odabrano {count} dana',
    uploadDocument: 'Dodaj dokument (opcionalno)',
    existingDocument: 'Postojeći dokument',
    replaceDocument: 'Zamijeni dokument',
    cancelReplaceDocument: 'Zadrži postojeći dokument',
    selected: 'Odabrano: {name}',

    // Stats
    inOfficeToday: 'U Uredu Danas',
    workingFromHome: 'Rad od Kuće',
    onVacation: 'Na Godišnjem',
    onLeave: 'Odsutno',
    totalTeam: 'Ukupno',

    // Alerts & Messages
    insufficientVacationDays: 'Nemate dovoljno dana godišnjeg! Imate {remaining} preostalih dana, a pokušavate rezervirati {requested} dana.',
    insufficientVacationDaysTitle: 'Nedovoljno Dana Godišnjeg Odmora',
    insufficientVacationDaysMessage: 'Pokušavate rezervirati {requested} dan(a) godišnjeg odmora, ali imate samo {remaining} dan(a) preostalo.',
    insufficientVacationDaysMessageAdmin: 'Pokušavate rezervirati {requested} dan(a) godišnjeg odmora, ali korisnik ima samo {remaining} dan(a) preostalo.',
    pleaseAdjustSelection: 'Molimo prilagodite svoj odabir kako bi se uklopio u vaš dostupni saldo godišnjeg odmora.',
    ok: 'U redu',
    selectBothDates: 'Molimo odaberite i početni i završni datum.',
    startDateBeforeEnd: 'Početni datum mora biti prije ili jednak završnom datumu.',
    invalidDateRange: 'Neispravan raspon datuma.',
    errorDeletingCollectiveVacation: 'Greška pri uklanjanju kolektivnog godišnjeg',
    error: 'Greška: {error}',
    genericError: 'Greška',
    unathorizedAccess: 'Nemate dozvolu za ovu akciju',
    errorChangingPassword: 'Greška pri promjeni lozinke',

    // Login
    appName: 'Radna evidencija',
    welcomeBack: 'Dobrodošli natrag',
    signInSubtitle: 'Prijavite se za nastavak',
    username: 'Korisničko ime',
    usernamePlaceholder: 'Unesite korisničko ime',
    emailAddress: 'Email adresa',
    enterEmail: 'Unesite svoj email',
    password: 'Lozinka',
    enterPassword: 'Unesite svoju lozinku',
    signIn: 'Prijavite se',
    signingIn: 'Prijavljujem...',
    forgotPassword: 'Zaboravili ste lozinku?',
    demoCredentials: 'Demo Podaci',
    signInWithMicrosoft: 'Prijavite se putem Microsofta',
    loginErrorNoAccount: 'Ne postoji WorkControl račun za ovu email adresu. Obratite se administratoru.',
    loginErrorCancelled: 'Prijava je prekinuta.',
    loginErrorGeneric: 'Prijava putem Microsofta nije uspjela. Pokušajte ponovno.',
    useCredentials: 'Koristite ove podatke za testiranje aplikacije:',

    // Password Change
    changePassword: 'Promijeni Lozinku',
    currentPassword: 'Trenutna Lozinka',
    newPassword: 'Nova Lozinka',
    confirmPassword: 'Potvrdi Novu Lozinku',
    passwordChanged: 'Lozinka je uspješno promijenjena',
    incorrectPassword: 'Trenutna lozinka nije ispravna',
    passwordMismatch: 'Nove lozinke se ne podudaraju',

    // Date formats
    monthYear: 'MMMM yyyy',
    dayMonth: 'MMM d',
    fullDate: 'MMMM d, yyyy',

    // Holidays
    holiday: 'Praznik',
    publicHoliday: 'Državni praznik',

    // Croatian month names in nominative case
    months: [
      'Siječanj', 'Veljača', 'Ožujak', 'Travanj', 'Svibanj', 'Lipanj',
      'Srpanj', 'Kolovoz', 'Rujan', 'Listopad', 'Studeni', 'Prosinac'
    ]
  }
};

// Helper function to get translation with parameter substitution
// Helper function to format Croatian month names in nominative case
export const formatCroatianMonth = (date, language = 'en') => {
  if (language !== 'hr') {
    return null; // Return null for non-Croatian, use date-fns
  }

  const monthIndex = date.getMonth();
  const year = date.getFullYear();
  const croatianMonths = TRANSLATIONS.hr.months;

  return `${croatianMonths[monthIndex]} ${year}`;
};

export const t = (key, params = {}, language = 'en') => {
  const keys = key.split('.');
  let translation = TRANSLATIONS[language];

  for (const k of keys) {
    translation = translation?.[k];
  }

  if (!translation) {
    console.warn(`Translation missing for key: ${key} in language: ${language}`);
    return key;
  }

  // Replace parameters like {count}, {date}, etc.
  let result = translation;
  Object.keys(params).forEach(param => {
    result = result.replace(new RegExp(`{${param}}`, 'g'), params[param]);
  });

  return result;
};
